import React from "react";
var __jsx = React.createElement;
import SquareSlider from "../squareSlider/SquareSlider";
var CardsSlider = function CardsSlider(cardsSlider) {
  return /*#__PURE__*/React.createElement(SquareSlider, cardsSlider);
};
export default CardsSlider;